import { useEffect, useState } from 'react'
import { supabase } from '../lib/supabase'

export function SiteNav() {
  const [email, setEmail] = useState<string | null>(null)

  useEffect(() => {
    supabase.auth.getUser().then(({ data }) => {
      setEmail(data.user?.email ?? null)
    })
  }, [])

  return (
    <nav className="bg-parchment-dark/30 border-b border-parchment-dark px-4 py-2 flex items-center justify-between text-sm">
      <div className="flex items-center gap-4">
        <a href="https://kaldoronline.cc" className="text-ink-light hover:text-accent transition-colors">&larr; Kaldor Online</a>
        <span className="text-ink-light/30 select-none">|</span>
        <a href="https://campaigns.kaldoronline.cc" className="text-ink-light hover:text-accent transition-colors" aria-current="page">Character Sheets</a>
        <a href="https://wiki.kaldoronline.cc" className="text-ink-light hover:text-accent transition-colors">Wiki</a>
      </div>
      <span className="text-ink-light/50 text-xs">{email ?? ''}</span>
    </nav>
  )
}
